<template>
  <div>
    <van-popup
      v-model:show="self.isShow"
      position="bottom"
      :style="{ height: '40%' }"
    >
    <van-date-picker
        v-model="currentDate"
        title="选择日期"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="dateCancel"
        @confirm="dateConfirm"
        />

    </van-popup>
  </div>
</template>

<script>

import func from "@/util/func.js";
import moment from "moment";


export default {
  name: "timeSelect",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
        minDate:null,
        maxDate:null,
        currentDate:[2000,1,1]
      }),
    },
   
  },
  components: {},
  data() {
    return {
   
    };
  },
  setup(props){
     let minDate = new Date(1900, 0, 1);
     //定义 maxDate 为现在的时间加5年
     let maxDate = new Date();
     maxDate.setFullYear(maxDate.getFullYear() + 5);
     
     //当前时间
     let currentDate = [moment().format('YYYY'),moment().format('MM'),moment().format('DD')];


     if(!func.isEmpty(props.self.minDate)){
        minDate = props.self.minDate;
     }

     if(!func.isEmpty(props.self.maxDate)){
        maxDate = props.self.maxDate;
     }

     if(!func.isEmpty(props.self.currentDate)){
        currentDate = props.self.currentDate;
     }

     return{
        minDate,
        maxDate,
        currentDate
     }
  },
  mounted() {

  },
  methods: {
    
    dateCancel(){
        let that=this;
        that.self.isShow=false;
    },
    dateConfirm(e){
        let that=this;
        let {selectedValues} = e;
        that.$emit('confirm',{
            value:selectedValues,
            valueStr:`${selectedValues[0]}-${selectedValues[1]}-${selectedValues[2]}`
        })
        that.dateCancel();

    },

  },
};
</script>

<style>
</style>